
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
directives: {
TransferDom
},
components: {
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
XDialog
},
methods: {
clear () {
this.p_name = ''
this.queryResult = {Data: [], TotalPage: 0}
},
async next () {
this.currentPage--
await this.doQuery()
},
async perv () {
this.currentPage++
await this.doQuery()
},
async doQuery () {
try {
this.$vux.loading.show({ text: ' 数据载入中' })
const queryPromise = await this.$http.get('/API/ExpertCustoms/Search'
, {params: {p_code: this.p_code, p_name: this.p_name, pageNumber: this.currentPage}})
this.queryResult = queryPromise.data
this.$vux.loading.hide()
if (this.queryResult.Data.length === 0) {
this.$vux.alert.show({
title: '通知',
content: '没有符合条件的记录'})
return
}
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
},
showDesc (index) {
let current = this.queryResult.Data[index]
console.log(current)
this.$router.push({path: '/ExpertDetails', query: {expertid: current.ID, currents: current}})
}
},
data () {
return {
queryResult: {Data: [], TotalPage: 0},
p_code: '',
p_name: '',
desc: null,
currentPage: 1
}
},
async activated () {
this.doQuery()

}
}



// WEBPACK FOOTER //
// ./src/components/ExpertIndex.vue